/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function changeVariantInformation(variant) {
  
  console.log("variant changed", variant)
  let currentDeliveryTime = document.getElementById(
    `delivery_time__${variant}`
  );
  let displayDeliverTime = document.getElementById("delivery_time_display");
  displayDeliverTime.innerHTML = currentDeliveryTime.innerHTML;
  // change inventory_quantity as well
  const currentInventory = document.getElementById(
    `inventory_quantity__${variant}`
  )?.innerHTML;
  const currentInventoryText = document.getElementById(
    `inventory_text__${variant}`
  )?.innerHTML;
  const currentInventoryColor = document.getElementById(
    `inventory_color__${variant}`
  )?.innerHTML
  
  const displayInventoryQuantity = document.getElementById(
    "inventory_quantity_display"
  )
  const displayInventoryCircle = document.getElementById(
    "inventory_quantity_circle"
  )
  
  const inventoryContainer = document.getElementById(
    "inventory_quantity_container"
  );
  console.log("before change", currentInventory,currentInventoryText, displayInventoryQuantity, currentInventoryColor)
  if (currentInventory > 0) {
    inventoryContainer.style = "display: table-row";
    displayInventoryQuantity.innerHTML = currentInventoryText;
    displayInventoryQuantity.className = `${currentInventoryColor.trim()}-text`;
    displayInventoryCircle.className = `${currentInventoryColor.trim()}-circle circle`;
  } else {
    inventoryContainer.style = "display: none";
  }
   console.log("after change", currentInventory,currentInventoryText, displayInventoryQuantity, currentInventoryColor)
}

document.addEventListener("variant:changed", function (event) {
  window.location.reload();
  // var variant = event.detail; // Gives you access to the whole variant details
  // changeVariantInformation(variant.variant.id);
});

// document.addEventListener(
//   "DOMContentLoaded",
//   function (event) {
//     // get the variant url params
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     const params = Object.fromEntries(urlSearchParams.entries());
//     console.log(params);
//     // if if available use them to update the delivery time
//     if (params.variant) {
//       var variant = params.variant; // Gives you access to the whole variant details
//       changeVariantInformation(variant);
//     }
//   },
//   false
// );



function loadSignUpForm(formId) {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
}


function docReady(fn) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

document.addEventListener("DOMContentLoaded", function () {
      console.log("listenting buttons")
  // Alle Elemente mit id beginnend mit 'button-' und endend auf '-ab-in-den-urlaub-guide'
  const buttons = document.querySelectorAll('[id^="button-"][id$="-ab-in-den-urlaub-guide"]');
    console.log("buttons", buttons)
  buttons.forEach(function (button) {
    // Optional: Regex prüfen für genaues Pattern-Matching

    if (!/^button-.*-ab-in-den-urlaub-guide$/.test(button.id)) return;
    console.log("adding event")

    button.addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.getElementById("form-ab-in-den-urlaub-guide");
    console.log("target", target)

      if (target) {
        const offset = 30;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});


// docReady(function () {
//   console.log("functin called");
//   const cookieName = "trs";
//   const trs =
//     document.cookie
//       .match("(^|;)\\s*" + cookieName + "\\s*=\\s*([^;]+)")
//       ?.pop() || "";
//   console.log(trs);
//   if (!trs) return;
//   let script = document.createElement("script");
//   script.type = "text/javascript";
//   script.src =
//     "//trck.einfacheauto.de/trck/etms/eatms.js?campaign_id=223&consent=1";
//   document.body.appendChild(script);
// });

// reload for cookiefirst consent (if needed)

// window.addEventListener("cf_init", function () {
//   if (window.CookieFirst && !window.CookieFirst.consent) {
//     window.addEventListener("cf_consent", function () {
//       window.location.reload();
//     });
//   }
// });
